type CurrencyType = '₹' | '$' | '€'

export const currency: CurrencyType = '$'

export const currentYear = new Date().getFullYear()

export const developedByLink = 'https://coderthemes.com/'

export const developedBy = 'Coderthemes'

export const contactUs = 'mailto:support@coderthemes.com'

export const buyLink = ''

export const basePath = ''

export const DEFAULT_PAGE_TITLE = 'Vietrro Social | Network, Community and Event for @ Copyright'
export const DEFAULT_PAGE_DESCRIPTION = 'Vietrro | Hiệp hội Quyền sao chép Việt Nam | Trung tâm Pháp luật và Tác quyền'
export const DEFAULT_PAGE_KEYWORDS = 'Vietrro, Quyền sao chép, Pháp luật và Tác quyền, quyen sao chép, phap luat và tac quyen'
